module.exports = __webpack_public_path__ + "img/company-header-texture.21fe965b.svg";